import get from '../get/'
import user from '@iez/lib/user/'

export default ({ fields, realtime, isCalledFromComponent }) => {
  const root = 'users'
  const request = () => user.id ? ({
    where: {
      id: {
        _eq: user.id
      }
    }
  }) : null

  return get({
    root,
    fields,
    request,
    realtime,
    one: true,
    waitFor: () => user.id,
    isCalledFromComponent
  })
}
